import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

export type TourState = {
  isTour: boolean;
  hasTouredCompositions: boolean;
  isSideBarOpen: boolean;
  isSideBarCompany: boolean;
  isControlPanelSpotlighted: boolean;
  stepIndex: number;
  isTourComplete: boolean;
  isVideoOpen: boolean;
  videoId: string;
};

export type TourActions = {
  setIsTour: (value: boolean) => void;
  setHasTouredCompositions: (value: boolean) => void;
  setIsSideBarOpen: (value: boolean) => void;
  setIsSideBarCompany: (value: boolean) => void;
  setIsControlPanelSpotlighted: (value: boolean) => void;
  setStepIndex: (value: number) => void;
  setIsTourComplete: (value: boolean) => void;
  setIsVideoOpen: (value: boolean) => void;
  setVideoId: (value: string) => void;
  reset: () => void;
};

export type TourStore = TourState & TourActions;

const DEFAULT_TOUR_STATE: TourState = {
  isTour: false,
  hasTouredCompositions: false,
  isSideBarOpen: false,
  isSideBarCompany: true,
  isControlPanelSpotlighted: false,
  stepIndex: 0,
  isTourComplete: false,
  isVideoOpen: false,
  videoId: '0',
};

export const useTourStore = create<TourStore>()(
  devtools(
    (set) => ({
      ...DEFAULT_TOUR_STATE,
      setIsTour: (value) => set({ isTour: value }),
      setHasTouredCompositions: (value) =>
        set({ hasTouredCompositions: value }),
      setIsSideBarOpen: (value) => set({ isSideBarOpen: value }),
      setIsSideBarCompany: (value) => set({ isSideBarCompany: value }),
      setIsControlPanelSpotlighted: (value) =>
        set({ isControlPanelSpotlighted: value }),
      setStepIndex: (value) => set({ stepIndex: value }),
      setIsTourComplete: (value) => set({ isTourComplete: value }),
      setIsVideoOpen: (value) => set({ isVideoOpen: value }),
      setVideoId: (value) => set({ videoId: value }),
      reset: () => set({ ...DEFAULT_TOUR_STATE }),
    }),
    { name: 'TourStore' }
  )
);
